(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var unitString = function unitString(unit) {
  return function (val) {
    return "" + val + unit;
  };
};
exports.default = unitString;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var validateNumber = function validateNumber(base) {
	return function (unknown) {
		var type = typeof unknown === 'undefined' ? 'undefined' : _typeof(unknown);
		return type === 'number' ? unknown : type === 'string' ? parseInt(unknown, base) : 0;
	};
};

exports.default = validateNumber;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var pipeAsync = function pipeAsync(fn) {
	for (var _len = arguments.length, fns = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		fns[_key - 1] = arguments[_key];
	}

	return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var _args = arguments;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (fns.length) {
							_context.next = 6;
							break;
						}

						_context.next = 3;
						return fn.apply(undefined, _args);

					case 3:
						_context.t0 = _context.sent;
						_context.next = 11;
						break;

					case 6:
						_context.t1 = pipeAsync.apply(undefined, fns);
						_context.next = 9;
						return fn.apply(undefined, _args);

					case 9:
						_context.t2 = _context.sent;
						_context.t0 = (0, _context.t1)(_context.t2);

					case 11:
						return _context.abrupt("return", _context.t0);

					case 12:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));
};

exports.default = pipeAsync;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pipe = function pipe(fn) {
  for (var _len = arguments.length, fns = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    fns[_key - 1] = arguments[_key];
  }

  return function () {
    return !fns.length ? fn.apply(undefined, arguments) : pipe.apply(undefined, fns)(fn.apply(undefined, arguments));
  };
};

exports.default = pipe;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var padDigits = function padDigits(pad) {
  return function (num) {
    return num < 10 ? pad + "num" : num.toString();
  };
};
exports.default = padDigits;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _padDigits = __webpack_require__(4);

var _padDigits2 = _interopRequireDefault(_padDigits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _padDigits2.default)(0);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unitString = __webpack_require__(0);

var _unitString2 = _interopRequireDefault(_unitString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _unitString2.default)('%');

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validateNumber = __webpack_require__(1);

var _validateNumber2 = _interopRequireDefault(_validateNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _validateNumber2.default)(10);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _array = __webpack_require__(9);

Object.keys(_array).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _array[key];
    }
  });
});

var _async = __webpack_require__(13);

Object.keys(_async).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _async[key];
    }
  });
});

var _functional = __webpack_require__(17);

Object.keys(_functional).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _functional[key];
    }
  });
});

var _object = __webpack_require__(20);

Object.keys(_object).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _object[key];
    }
  });
});

var _string = __webpack_require__(25);

Object.keys(_string).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _string[key];
    }
  });
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fillFrom = __webpack_require__(10);

Object.defineProperty(exports, 'fillFrom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fillFrom).default;
  }
});

var _fillWith = __webpack_require__(11);

Object.defineProperty(exports, 'fillWith', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fillWith).default;
  }
});

var _uniq = __webpack_require__(12);

Object.defineProperty(exports, 'uniq', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uniq).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fillBy = exports.fillBy = function fillBy(increment) {
	return function () {
		var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		return function () {
			var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
			var end = arguments[1];
			return start <= end ? fillBy(increment)([].concat(_toConsumableArray(arr), [start]))(start + increment, end) : arr;
		};
	};
};

exports.default = fillBy(1)();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fillWith = function fillWith() {
	var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return function (num) {
		var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		return !num ? arr : fillWith([].concat(_toConsumableArray(arr), [val]))(num - 1, val);
	};
};

exports.default = fillWith();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * @param {array} arr input array containing the values you wish sort by uniqueness
 * @param {function} fn optional comparator function for traversing arrays of objects
 */
var uniq = function uniq(arr) {
	var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (obj) {
		return obj;
	};

	var hash = {};

	return arr.filter(function (obj) {
		if (hash[fn(obj)]) return false;else {
			hash[fn(obj)] = true;
			return true;
		}
	});
};

exports.default = uniq;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _composeAsync = __webpack_require__(14);

Object.defineProperty(exports, 'composeAsync', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_composeAsync).default;
  }
});

var _debounce = __webpack_require__(15);

Object.defineProperty(exports, 'debounce', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_debounce).default;
  }
});

var _pipeAsync = __webpack_require__(2);

Object.defineProperty(exports, 'pipeAsync', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pipeAsync).default;
  }
});

var _throttle = __webpack_require__(16);

Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_throttle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pipeAsync = __webpack_require__(2);

var _pipeAsync2 = _interopRequireDefault(_pipeAsync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var composeAsync = function composeAsync() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return _pipeAsync2.default.apply(undefined, _toConsumableArray(fns.reverse()));
};

exports.default = composeAsync;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var debounce = function debounce(fn, time) {
	var timeout = void 0;

	return function () {
		var _this = this;

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var call = function call() {
			return fn.call.apply(fn, [_this].concat(args));
		};

		clearTimeout(timeout);
		timeout = setTimeout(call, time);
	};
};

exports.default = debounce;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var throttle = function throttle(fn, limit) {
	var lastCall = void 0;
	var timestamp = void 0;

	return function () {
		var _this = this;

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		var call = function call() {
			return fn.call.apply(fn, [_this].concat(args));
		};

		if (!timestamp) {
			call();
			timestamp = Date.now();
		} else {
			clearTimeout(lastCall);
			lastCall = setTimeout(function () {
				if (Date.now() - timestamp >= limit) {
					call();
					timestamp = Date.now();
				}
			}, limit - (Date.now() - timestamp));
		}
	};
};

exports.default = throttle;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = __webpack_require__(18);

Object.defineProperty(exports, 'compose', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_compose).default;
  }
});

var _pipe = __webpack_require__(3);

Object.defineProperty(exports, 'pipe', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pipe).default;
  }
});

var _sideEffects = __webpack_require__(19);

Object.defineProperty(exports, 'sideEffects', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sideEffects).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pipe = __webpack_require__(3);

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var compose = function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return _pipe2.default.apply(undefined, _toConsumableArray(fns.reverse()));
};
exports.default = compose;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var sideEffects = function sideEffects(fn) {
	return function (arg) {
		fn(arg);
		return arg;
	};
};

exports.default = sideEffects;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _equals = __webpack_require__(21);

Object.defineProperty(exports, 'equals', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_equals).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deepEqual = __webpack_require__(22);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _deepEqual2.default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(23);
var isArguments = __webpack_require__(24);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 23 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _capitalize = __webpack_require__(26);

Object.defineProperty(exports, 'capitalize', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_capitalize).default;
  }
});

var _padDigits = __webpack_require__(4);

Object.defineProperty(exports, 'padDigits', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_padDigits).default;
  }
});

var _padZero = __webpack_require__(5);

Object.defineProperty(exports, 'padZero', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_padZero).default;
  }
});

var _percentString = __webpack_require__(6);

Object.defineProperty(exports, 'percentString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_percentString).default;
  }
});

var _percent = __webpack_require__(27);

Object.defineProperty(exports, 'percent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_percent).default;
  }
});

var _pixelString = __webpack_require__(28);

Object.defineProperty(exports, 'pixelString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pixelString).default;
  }
});

var _timeString = __webpack_require__(29);

Object.defineProperty(exports, 'timeString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeString).default;
  }
});

var _unitString = __webpack_require__(0);

Object.defineProperty(exports, 'unitString', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_unitString).default;
  }
});

var _validateDecimal = __webpack_require__(7);

Object.defineProperty(exports, 'validateDecimal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_validateDecimal).default;
  }
});

var _validateHexadecimal = __webpack_require__(30);

Object.defineProperty(exports, 'validateHexadecimal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_validateHexadecimal).default;
  }
});

var _validateNumber = __webpack_require__(1);

Object.defineProperty(exports, 'validateNumber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_validateNumber).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 * @param {string} str input string
 * @param {string} split split or character to split string at
 */
var capitalize = function capitalize(str) {
	var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
	return str.split(split).map(function (word) {
		return word.slice(0, 1).toUpperCase() + word.slice(1);
	}).join(split);
};

exports.default = capitalize;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _percentString = __webpack_require__(6);

var _percentString2 = _interopRequireDefault(_percentString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var percent = function percent(x, y) {
  return (0, _percentString2.default)(Math.round(x / y * 100));
};
exports.default = percent;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unitString = __webpack_require__(0);

var _unitString2 = _interopRequireDefault(_unitString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _unitString2.default)('px');

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _validateDecimal = __webpack_require__(7);

var _validateDecimal2 = _interopRequireDefault(_validateDecimal);

var _padZero = __webpack_require__(5);

var _padZero2 = _interopRequireDefault(_padZero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hours = function hours(time) {
	return Math.floor(time / 3600);
};
var minutes = function minutes(time) {
	return Math.floor(time / 60);
};
var seconds = function seconds(time) {
	return Math.floor(time % 60);
};

var timeString = function timeString(char) {
	return function (time) {
		var valid = (0, _validateDecimal2.default)(time);

		return !hours(time) ? '' + minutes(time) + char + (0, _padZero2.default)(seconds(time)) : '' + hours(time) + char + (0, _padZero2.default)(minutes(time)) + char + (0, _padZero2.default)(seconds(time));
	};
};

exports.default = timeString(':');

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validateNumber = __webpack_require__(1);

var _validateNumber2 = _interopRequireDefault(_validateNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _validateNumber2.default)(16);

/***/ })
/******/ ]);
});
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/smalldash/dist/module.js
// module id = 16
// module chunks = 3